import { Application, Container } from 'pixi.js';
import { COLORS } from '@/config/colors';

/**
 * Pixi application + layer layout.
 * world: container moved by the camera (arena, entities, fx)
 * ui: screen-fixed HUD layer
 */
export class Stage {
  private constructor(
    readonly app: Application,
    readonly world: Container,
    readonly ui: Container,
  ) {}

  static async create(): Promise<Stage> {
    const app = new Application();
    await app.init({
      background: COLORS.background,
      resizeTo: window,
      antialias: true,
      preference: 'webgpu', // Including Xbox Edge: WebGPU if available, otherwise WebGL2
    });
    document.getElementById('app')!.appendChild(app.canvas);

    const world = new Container();
    const ui = new Container();
    app.stage.addChild(world, ui);

    return new Stage(app, world, ui);
  }

  get width(): number {
    return this.app.screen.width;
  }

  get height(): number {
    return this.app.screen.height;
  }
}
